import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=d5772f8c&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
import style0 from "./Person.vue?vue&type=style&index=0&id=d5772f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5772f8c",
  null
  
)

export default component.exports